export default __webpack_public_path__ + "static/media/reports.6e6a1dd6.svg";